import React, { Component } from 'react';
import { Link } from 'react-router';


var OldTests = React.createClass({
  render: function(){
    function ballsMin(balls, name){
      var good = 'true',
          bad  = 'false';

      if(name == 'CM' && balls >= 11){
        return good;
      }else if(name == 'Windows' && balls >= 10){
        return good;
      }else if(name == 'Hardware' && balls >= 10){
        return good;
      }else if(name == 'Wi-Fi' && balls >= 10){
        return good;
      }else if(name == 'Mac OS' && balls >= 10){
        return good;
      }else if(name == 'Net' && balls >= 10){
        return good;
      }else if(name == 'English' && balls >= 5){
        return good;
      }

      return bad;
    }
    return(
      <div className="Profile tests">
      <Link className="SelectSpecialtiesOpen top" to={"/admin/specialty/" + this.props.specialty + "/profile/" + this.props.profile.sfid + "/"}>Назад</Link>
        {Object.keys(this.props.profile.categoriesTest).map((item, i) => (
            <div className={"blockField " + ballsMin(this.props.profile.categoriesTest[item], item)} key={i}>
              <div className="nameField">{item}</div>
              <div className="dataField">{this.props.profile.categoriesTest[item]}</div>
            </div>)
          )}
        <div className="blockField"><div className="uniteField"></div></div>
        {this.props.profile.tests.map(function(item, i){
          var idSelect,
              typeAnswer = false;

          console.log(item);
          for (var i2 = 0, l = item.answers.length; i2 < l; i2++) {
            if(item.answers[i2].select){
              idSelect = i2;
              if(item.answers[i2].type){
                typeAnswer = true;
              }
            }
          }
          return(
            <div className={"blockField vert" + (typeAnswer ? ' true' : ' false')} key={i}>
              <div className="nameField">{item.question}</div>
              <div className="dataField">{typeof idSelect == 'undefined' ? '' : item.answers[idSelect].text}</div>
            </div>
          );
        })}
      </div>
    );
  }
})

var NewTests = React.createClass({
  render: function(){
    function ballsMin(balls, name){
      var good = 'true',
          bad  = 'false';

      if(name == 'CM' && balls >= 11){
        return good;
      }else if(name == 'Windows' && balls >= 10){
        return good;
      }else if(name == 'Hardware' && balls >= 10){
        return good;
      }else if(name == 'Wi-Fi' && balls >= 10){
        return good;
      }else if(name == 'Mac OS' && balls >= 10){
        return good;
      }else if(name == 'Net' && balls >= 10){
        return good;
      }else if(name == 'English' && balls >= 5){
        return good;
      }

      return bad;
    }
    return(
      <div className="Profile tests">
      <Link className="SelectSpecialtiesOpen top" to={"/admin/specialty/" + this.props.specialty + "/profile/" + this.props.profile.sfid + "/"}>Назад</Link>
      <div class="headlineWrapper"><div class="headline">Навыки ({this.props.profile.categoriesTest.skills.length})</div></div>
        {this.props.profile.categoriesTest.skills.map((item, i) => (
            <div className="blockField vert" key={i}>
              <div className="nameField">{item.nameSkill}</div>
              <div className="dataField">{item.balls || 0}<span style={{width: 30, height: 30, background: typeof item.balls != 'undefined' && item.balls > item.minBall ? 'green' : '#ffa0a0', lineHeight: '30px', borderRadius: 15, display: 'inline-block', margin: '0 10px'}}>{typeof item.balls != 'undefined' && item.balls > item.minBall ? '>' : '<'}</span>{item.minBall}</div>
            </div>)
          )}
        <div class="headlineWrapper"><div class="headline">Вопросы ({this.props.profile.tests.questions.length})</div></div>
        {this.props.profile.tests.questions.map(function(item, i){
          var idSelect,
              typeAnswer = false;

          console.log(item);
          for (var i2 = 0, l = item.answers.length; i2 < l; i2++) {
            if(item.answers[i2].select){
              idSelect = i2;
              if(item.answers[i2].type){
                typeAnswer = true;
              }
            }
          }
          return(
            <div className="blockField vert" key={i}>
              <div className="nameField">{item.question}</div>
              <div className="dataField">{typeof idSelect == 'undefined' ? '' : item.answers[idSelect].name}</div>
            </div>
          );
        })}

        
      </div>
    );
  }
})


var Tests = React.createClass({
  render: function(){
    var newVersionTime = new Date('2019-01-19'),
        profileCreateTime = new Date(this.props.profile.createdAt);

    console.log(newVersionTime, profileCreateTime)

    if(newVersionTime > profileCreateTime){
      return (
        <OldTests profile={this.props.profile} specialty={this.props.specialty}/>
      )
    }else{
      // console.log('новый')
      return (
        <NewTests profile={this.props.profile} specialty={this.props.specialty}/>
      )
    }
    
  }
});

export default Tests;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Tests/index.jsx
 **/